<template>
  <q-page-container>
    <q-page class="">
      <div class="title-page">Dados da solicitação</div>
      <section class="section-service col-12">
        <q-option-group
          hidden
          v-model="panel"
          inline
          :options="[
            { label: 'Tab-1', value: 'tab-1' },
          ]"
        />
        <q-tab-panels v-model="panel" class="panel-services">
          <q-tab-panel
            name="tab-1"
            class="col-12 row items-center justify-center"
          >
            <q-form ref="formtab1">
              <div class="group-input col-12 row q-mt-sm">
                <label for="type-os">Tipo de OS</label>
                <q-select
                  id="type-os"
                  class="col-12 q-mt-sm form-tabulacao"
                  outlined
                  dense
                  ref="typeOSRef"
                  v-model="requestData.typeOS"
                  color="red-9"
                  @filter="getTypeOsByClassification"
                  use-input
                  hide-selected
                  fill-input
                  input-debounce="0"
                  :options="optionsTypeOSByClassification"
                  option-value="value"
                  option-label="text"
                  bg-color="white"
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                  lazy-rules
                />
              </div>
              <div
                class="group-input col-12 row q-mt-sm"
              >
                <label for="os_install_number">Informe o número da OS</label>
                <q-input
                  id="os_install_number"
                  ref="osInstallNumberRef"
                  v-model="requestData.osNumber"
                  class="col-12 q-mt-sm"
                  bg-color="white"
                  maxlength="10"
                  color="red-9"
                  dense
                  outlined
                  type="text"
                  unmasked-value
                  placeholder="0000000000"
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                  lazy-rules
                />
              </div>
              <!-- <div
                class="group-input col-12 column q-mt-lg"
              >
                <label for="write-off-code">Tipo de agendamento</label>
                <div class="flex row justify-around">
                  <q-radio
                    v-model="requestData.movimentscheduling"
                    keep-color
                    size="lg"
                    :val="1"
                    label="Realizar agendamento"
                    color="red-6"
                    disable
                  />
                  <q-radio
                    v-model="requestData.movimentscheduling"
                    keep-color
                    size="lg"
                    :val="0"
                    label="Abertura imediata"
                    color="red-6"
                    disable
                  />
                </div>
              </div> -->

              <div class="group-input col-12 row q-mt-md">
                <label for="observation">Observação</label>
                <div class="col-12 row flex justify-around">
                  <q-input
                    v-model="requestData.observation"
                    class="col-12 q-mt-sm"
                    bg-color="white"
                    color="red-9"
                    maxlength="120"
                    outlined
                    autogrow
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                  />
                </div>
              </div>
            </q-form>
          </q-tab-panel>
        </q-tab-panels>
        <section>
          <div>
            <q-footer>
              <q-toolbar elevated>
                <div
                  class="flex col-12 row items-center justify-between"
                >
                  <div class="col-4 justify-center flex items-center">
                    <q-btn
                      unelevated
                      outline
                      rounded
                      color="red-9"
                      @click="$emit('removeEdit')"
                      label="Cancelar"
                    />
                  </div>
                  <div class="col-4 justify-center flex items-center">
                    <q-btn
                      unelevated
                      rounded
                      color="red-9"
                      @click="validateForm()"
                      label="Concluir"
                    />
                  </div>
                </div>
              </q-toolbar>
            </q-footer>
          </div>
        </section>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
import DateTimePicker from "@/components/DateTimePicker";
import SelectCheckbox from "@/components/SelectCheckbox";
import moment from "moment";
import { useQuasar } from "quasar";
import { onMounted, reactive, ref } from "vue";

export default {
  name: "FormSolicitation",
  components: {
    SelectCheckbox,
    DateTimePicker,
  },
  props: {
    listTypeOS: Array,
    optionsTypeOS: Array,
    optionsTypeOSByClassification: Array,
    optionsActionOs: Array,
    itemOsContract: Object,
  },
  emits: [
    "saveSchemaRequest",
    "clearSchemaRequest",
    "removeEdit",
  ],

  setup(props, { emit }) {
    moment.locale("pt-br");

    const $q = useQuasar();

    let panel = ref("tab-1");

    let requestData = reactive(props.itemOsContract);

    let schemaRequest = reactive({
      object_id: "",
      osNumber: "",
      typeOS: "",
      statusOS: 1,
      observation: "",
      check: false,
      replicate: false,
      source: "",
    });
    const formtab1 = ref(null);
    const listTypeOS = ref([]);

    const optionsItens = reactive({
      optionsTypeOS: listTypeOS,
    });

    function setTypeOsByServiceOption() {
      if (props.optionsTypeOSByClassification.length == 1) {
        requestData.typeOS = props.optionsTypeOSByClassification[0];
      }
    }

    function getTypeOsByClassification(val, update) {
      let selectedOption = props.optionsActionOs.find(
        (option) => option.id_acao == requestData.action
      );
      update(() => {
        optionsItens.optionsTypeOS = props.listTypeOS.filter((optionTypeOS) => {
          return (
            optionTypeOS.id_classificacao == selectedOption.id_classificacao
          );
        });
      });
    }

    async function validateForm() {
      let validation = false;
      validateSchemaRequest();

        validation = await formtab1.value.validate();

        if (validation) {
          await emitData();
        }
      return validation;
    }

    async function emitData() {
      emit("saveSchemaRequest", requestData);
    }

    function validateSchemaRequest() {
      if (
        requestData.osNumber == "" ||
        requestData.typeOS == "" ||
        requestData.observation == ""
      ) {
        $q.notify({
          message: "Todos os campos são obrigatórios.",
          color: "red-9",
          position: "top",
          timeout: 3000,
        });
        return false;
      }
      return true;
    }

    onMounted(() => {
      setTypeOsByServiceOption();
    });

    return {
      panel,
      schemaRequest,
      requestData,
      optionsItens,
      formtab1,
      validateSchemaRequest,
      validateForm,
      getTypeOsByClassification,
    };
  },
};
</script>

<style scoped lang="scss">
label {
  font-family: Roboto;
  font-style: normal;
}

.q-page-container {
  padding-bottom: 0px !important;
}

.label-checkbox-confirm {
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  letter-spacing: 0.01em !important;
  color: #999999 !important;
}

footer {
  background: #e5e5e5 !important;
  height: 12vh;

  .q-toolbar {
    height: 12vh;
  }

  .div-progress {
    height: 8vh;
  }

  .div-btn-next {
    height: 8vh;
  }
}

.section-service {
  width: 100%;

  .panel-services {
    background: transparent !important;
    overflow: hidden !important;

    .title-page {
      font-weight: bold;
      font-size: 18px;
      line-height: 19px;
      text-transform: uppercase;
      color: #e2262d;
    }

    .group-input {
      label {
        font-weight: bold;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
      }
    }

    .label-requests-number {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.5);
    }

    .label-requests-description {
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.8);
    }
  }
}
</style>
